import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import SimpleBar from "simplebar-react";

import withRouter from "../../components/Common/withRouter";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { connect, useSelector } from "react-redux";
import { changeMenuActived, showTopbarInsideAction } from "../../store/actions";
import { Card, CardBody, CardText } from "reactstrap";
import logoDefenderSm from "../../assets/images/logo-defender-sm.png";
import config from "../../config";
import SidebarData from "./SidebarData";

const Sidebar = (props) => {

  const { menuActivedObj, user, menus, topbarInside } = useSelector((state) => ({
    menuActivedObj: state.Layout.menuActived,
    user: state.login.profile,
    menus: state.login.user,
    topbarInside: state.Layout.topbarInside,
  }));


  const ref = useRef();
  const [IDMenu, setIDMenu] = useState(menuActivedObj?.ID_Menu);
  const [showCardInfoMenu, setshowCardInfoMenu] = useState(false);
  const [dataCardIndoMenu, setDataCardIndoMenu] = useState({});
  const [yFixed, setyFixed] = useState(0)
  const cardRef = useRef();

  const findMenuInTree = (menus, targetCodigo) => {
    for (const menu of menus || []) {
      if (menu?.Codigo_Transacao?.toUpperCase() === targetCodigo.toUpperCase() && menu?.Disponivel === 'S') {
        return menu;
      }
      if (menu.childrens && menu.childrens.length > 0) {
        const foundInChildren = findMenuInTree(menu.childrens, targetCodigo);
        if (foundInChildren) {
          return foundInChildren;
        }
      }
    }
    return null;
  };

  const handlerMenusInternal = (idMenu, isActiveSubMenus, onlyCache = false) => {
    setIDMenu(idMenu);
    
    if (idMenu == 98) {
      const internalTopMenus = SidebarData.filter((i) => i.ID_Menu === idMenu)[0]?.TopBarInternalMenu || [];
      const menu = {
        id: idMenu,
        isActive: "S",
        payload: internalTopMenus,
      };
      props.showTopbarInsideAction(menu);
    }
  };

  let dataMenus = menus?.resultset_4 || [];

  if (!dataMenus?.filter((i) => i.ID_Menu === 98)?.length) {
    dataMenus?.unshift(
      ...(config.NODE_ENV === "development"
        ? SidebarData
        : [])
    );
  }

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    if (menuActivedObj?.Codigo_Transacao && menus?.resultset_4) {
      const activeMenu = findMenuInTree(menus.resultset_4, menuActivedObj.Codigo_Transacao);
      
      if (activeMenu && activeMenu.ID_Menu) {
        setIDMenu(activeMenu.ID_Menu);
        
        if (activeMenu.Menu_Interno === "S") {
          const menuAlreadyLoaded = topbarInside?.id === activeMenu.ID_Menu && 
                                   topbarInside?.isActive === "S" && 
                                   topbarInside?.payload?.length > 0;
          
          if (!menuAlreadyLoaded) {
            handlerMenusInternal(activeMenu.ID_Menu, activeMenu.Menu_Interno, true);
          }
        }
      }
    }
  }, [menuActivedObj, menus, topbarInside]);


  const onMouseEnterHandler = (e, item) => {
    if(item.ID_Menu !== dataCardIndoMenu.ID_Menu){
      setDataCardIndoMenu(item)
      setyFixed(window.document.querySelector('#'+item.Codigo_Transacao)?.childNodes[0]?.offsetTop)
    }
    setshowCardInfoMenu(true)
  };
  const onMouseLeaveHandler = () => {
    setshowCardInfoMenu(false)
  };

  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div id="sidebar-top-logo">
          <img src={logoDefenderSm} />
        </div>
        <SimpleBar className="h-100" ref={ref}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu-item">
              {dataMenus?.map((item, key) => (
                <React.Fragment key={key}>
                  <li
                    onMouseEnter={(e) => onMouseEnterHandler(e, item)}
                    onMouseLeave={onMouseLeaveHandler}
                    key={key}
                    id={item?.Codigo_Transacao}
                    className={`
                    ${(item?.Disponivel && item?.Disponivel == "N") ? "disabled" : ""}                     
                    ${
                      (menuActivedObj?.Codigo_Transacao == item?.Codigo_Transacao || IDMenu == item?.ID_Menu)
                        ? "mm-active"
                        : ""
                    }`}
                  >
                    <Link
                      onClick={() => {
                        if(item?.Disponivel && item?.Disponivel == "N") return
                        handlerMenusInternal(
                          item?.ID_Menu,
                          item?.Menu_Interno
                        )
                      }
                      }
                      to={(item?.Disponivel && item?.Disponivel == "S" ? "/"+item?.Codigo_Transacao : "/#")}
                      aria-label={item?.Nome_Item || ""}
                      data-id={item?.ID_Menu || ""}
                      data-transation={item?.Codigo_Transacao || ""}
                      className={`${
                        (menuActivedObj?.Codigo_Transacao == item?.Codigo_Transacao || IDMenu == item?.ID_Menu)
                          ? "active"
                          : ""
                      }`}
                    >
                      <div className="icone" ref={cardRef}>
                        {item?.Icone_Item.includes('<svg') ?
                          <div dangerouslySetInnerHTML={{__html: item?.Icone_Item}}></div>
                          : 
                          <i className={ item?.Icone_Item }></i>
                          }
                      </div>
                      {item.issubMenubadge && (
                        <span
                          className={
                            "badge rounded-pill float-end " + item.bgcolor
                          }
                        >
                          {" "}
                          {item.badgeValue}{" "}
                        </span>
                      )}
                      <span>{props.t(item.Nome_Item)}</span>
                    </Link>
                  </li>
                </React.Fragment>
              ))}
            </ul>
          </div>
        </SimpleBar>

        <Card
          style={{ top: yFixed+80, left:60, width: 315 }}
          onMouseEnter={() => setshowCardInfoMenu(true)}
          onMouseLeave={() => setshowCardInfoMenu(false)}
          className={`card-float-menu ${showCardInfoMenu ? "d-block" : "d-none"}`}
        >
        
          <div className="card-menu-sidebar-info">
            <h6 className="card-header">
                {dataCardIndoMenu.Nome_Item}
                <i className="fas fa-angle-right"></i>
            </h6>
            <CardBody>
              <CardText>
                <p className="p-0" dangerouslySetInnerHTML={{__html: dataCardIndoMenu.Descricao_Item}}></p>
              </CardText>
            </CardBody>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  showTopbarInsideAction: PropTypes.func,
  changeMenuActived: PropTypes.func,
  location: PropTypes.object,
  t: PropTypes.any,
  menu: PropTypes.any,
};

const MapStateToProps = (state) => {
  return { ...state.Layout };
};
export default connect(MapStateToProps, {
  showTopbarInsideAction,
  changeMenuActived,
})(withRouter(withTranslation()(Sidebar)));
